import { Client, ThreadID, createUserAuth, Where } from '@textile/hub';
import * as auth from './auth';

const _threadID = 'bafksepc2alijsqm2ulegoedwxkkbit3tz3jl33qjjloyjlp6usmb4oa';

async function createUserAuthWithKeyInfo(keyInfo) {
    //Create an expiration and create a signature. 60s or less is recommended
    const expiration = new Date(Date.now() + 60 * 1000);
    ////Generate a new UserAuth
    const userAuth = await createUserAuth(
        keyInfo.key,
        keyInfo.secret,
        expiration
    );
    console.log(userAuth);
    return userAuth;
}

export async function insertEmployee(
    employee_id,
    employer_id,
    wallet_address,
    name,
    country = '',
    date_of_birth = '',
    department = '',
    email = '',
    employee_type = '',
    job_title = '',
    join_date = '',
    payment_frequency = '',
    preferred_currency = '',
    amount = ''
) {
    const { client, threadID } = await setupDB();

    var employee = {
        _id: '',
        employee_id: employee_id,
        amount: amount,
        employer_id: employer_id,
        wallet_address: wallet_address,
        name: name,
        country: country,
        date_of_birth: date_of_birth,
        department: department,
        email: email,
        employee_type: employee_type,
        job_title: job_title,
        join_date: join_date,
        payment_frequency: payment_frequency,
        preferred_currency: preferred_currency
    };

    return await client.create(threadID, 'employee', [employee]);
}

export async function insertEmployer(
    company_name,
    brand_name,
    wallet_address,
    address,
    country,
    location,
    zipcode,
    pay_date,
    autoplay_enable,
    payroll_enable,
    salary_advance_enable
) {
    const { client, threadID } = await setupDB();

    var employer = {
        _id: '',
        company_name: company_name,
        brand_name: brand_name,
        wallet_address: wallet_address,
        address: address,
        country: country,
        location: location,
        zipcode: zipcode,
        pay_date: pay_date,
        autoplay_enable: autoplay_enable,
        payroll_enable: payroll_enable,
        salary_advance_enable: salary_advance_enable
    };

    return await client.create(threadID, 'employer', [employer]);
}

export async function getAllEmployees() {
    const { client, threadID } = await setupDB();
    const employees = await client.find(threadID, 'employee', new Where());
    return employees;
}

export async function getAllEmployers() {
    const { client, threadID } = await setupDB();
    const employers = await client.find(threadID, 'employer', new Where());
    return employers;
}

async function setupDB() {
    //Initialize the client
    const client = await Client.withUserAuth(
        await createUserAuthWithKeyInfo({
            key: 'bff2q62gt42tauetcu6nusnqwlu',
            secret: 'blfa27l2iypva6umsqptajdl5x3dxgo23cllo2ja'
        })
    );
    const threadID = ThreadID.fromString(_threadID);

    const identity = await auth.getIdentity();
    const userToken = await client.getToken(identity);

    return { client, threadID };
}
